<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Referencia bancaria</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <div v-if="fechaValida">
                          <p>
                            Para generar correctamente tu referencia recuerda que tus datos personales deben
                            estar completos y actualizados. Revisa la sección de Información Escolar para verificar tus datos.
                          </p>
                            <v-btn @click="imprimirReferencia"  v-show="$mq !== 'sm'">Imprimir</v-btn>
                            <v-btn @click.native="descargarReferencia">Descargar</v-btn>
                        </div>
                        <p v-else>
                            Se encuentra fuera del periodo para generar referencia bancaria
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="cargandoDatos" max-width="350px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="width: 250px" v-text="mensaje"></span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showErrorDialog" max-width="450px" persistent>
            <v-card>
                <v-card-title
                        class="headline red--text"
                        primary-title
                >
                    Ha ocurrido un problema
                </v-card-title>

                <v-card-text>
                    Por el momento no es posible generar la referencia bancaria, intente más tarde.
                    <b>Nota:</b> Si los problemas persisten debes de comunicarte con tu coordinador o servicios escolares.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red"
                            flat
                            @click="showErrorDialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import fileSaver from 'file-saver'
  import printJS from 'print-js'

  export default {
    name: 'ReferenciaBancaria',
    data: () => ({
      cargandoDatos: false,
      showErrorDialog: false,
      fechaValida: false,
      mensaje: ''
    }),
    mounted () {
      this.validarFecha()
    },
    methods: {
      imprimirReferencia () {
        this.cargandoDatos = true
        this.mensaje = 'Espera un momento, se está generando el documento.'
        axios.get('alumno/referencia-bancaria', {responseType: 'arraybuffer'})
          .then(response => {
            this.cargandoDatos = false
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            const fileUrl = URL.createObjectURL(blob)
            printJS(fileUrl)
          })
          .catch(() => {
            console.log('error')
            this.cargandoDatos = false
            this.showErrorDialog = true
          })
      },
      descargarReferencia () {
        this.cargandoDatos = true
        this.mensaje = 'Espera un momento, se está generando el documento.'
        axios.get('alumno/referencia-bancaria', {responseType: 'arraybuffer'})
          .then(response => {
            this.cargandoDatos = false
            const blob = new Blob([response.data], {type: response.headers['content-type']})
            fileSaver.saveAs(blob, 'referencia-bancaria.pdf')
          })
          .catch(() => {
            this.showErrorDialog = true
          })
      },
      validarFecha () {
        this.cargandoDatos = true
        this.mensaje = 'Espera un momento, se está validando la generación de referencias.'
        axios.get('alumno/referencia-bancaria/valida-fecha')
          .then(() => {
            this.cargandoDatos = false
            this.fechaValida = true
          })
          .catch(() => {
            this.cargandoDatos = false
            this.fechaValida = false
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/inscripciones/ReferenciaBancariaPage.vue